"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ElementIds_1 = require("../../enums/ElementIds");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const OneTimeCodeForgot_vue_1 = tslib_1.__importDefault(require("./OneTimeCodeForgot.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'one-time-code-container',
    data: () => {
        return {
            oneTimeCode: '',
            valid: false,
            isSubmitting: false,
            navigatingBack: false,
        };
    },
    computed: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        actionText() {
            return this.getSiteText('Forgot.VerificationCode.EnterCode');
        },
        hasError() {
            return (this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        errorText() {
            return this.getSiteText(`ChallengeStatus.${this.$store.state.challengeStatus}`);
        },
        buttonText() {
            var _a;
            return (_a = this.$options.filters) === null || _a === void 0 ? void 0 : _a.sitetext('Forgot.VerificationCode.Verify');
        },
        buttonDisabled() {
            return !this.valid;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        scenarioType() {
            if (this.$store.getters.isForgotUsernameWorkflow)
                return 'ForgotUsername';
            if (this.$store.getters.isForgotPasswordWorkflow)
                return 'ForgotPassword';
            return 'Registration';
        },
        isSyncing() {
            return this.$store.getters.isSyncing;
        },
        isLoading() {
            return this.isSubmitting || this.isSyncing || this.$store.getters.isSubmittingAuthenticatedModel;
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        async submitForm() {
            if (this.isSubmitting || !this.valid) {
                return;
            }
            let challenge = {
                ...this.currentChallenge,
                ValidationKey: this.oneTimeCode,
            };
            // set the state to remain on the same screen for invalid code
            this.$store.commit('setRemainOnStepUpScreenOnFailure', true);
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            this.isSubmitting = true;
            await this.$store.dispatch('submitChallenge', challenge);
            this.isSubmitting = false;
            // reset code if there are errors
            if (this.hasError) {
                this.oneTimeCode = '';
            }
            const workflow = (0, userTelemetry_1.getWorkflowName)(this.$store.getters.workflow);
            if (workflow !== userTelemetry_1.workflowName.unknown) {
                let event = {
                    workflowName: workflow,
                    stepType: userTelemetry_1.stepType.progression,
                    stepName: userTelemetry_1.stepName.verification_code,
                    action: userTelemetry_1.userAction.continue_clicked,
                };
                if (this.hasError) {
                    event.eventProperties = {
                        'error': this.$store.state.challengeStatus,
                    };
                }
                void userTelemetry_1.telemetry.custom(event);
            }
        },
        async changeStepupMethod() {
            // Switching back from OTP input to method selection
            if (this.navigatingBack) {
                return;
            }
            this.navigatingBack = true;
            this.oneTimeCode = '';
            await this.$store.dispatch('goToPreviousChallenge');
            this.navigatingBack = false;
        },
        otpCodeEntered({ valid, code }) {
            this.valid = valid;
            this.oneTimeCode = code;
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        OneTimeCode: OneTimeCodeForgot_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
